import * as React from 'react';
import { andreasImg, ketutImg, mariaImg } from '../../assets';

interface TestimonialProps {
  imageSrc: string;
  imageAlt: string;
  name: string;
  company: string;
  testimonial: string;
}

export const SuccessStories: React.FC = () => {
  const testimonials: TestimonialProps[] = [
    {
      imageSrc: ketutImg,
      imageAlt: 'Profile picture of Sarah Chen',
      name: 'Sarah Chen',
      company: 'Managing Partner, Alpha Ventures',
      testimonial: "Tokenizing our fund increased our capital raise by 40% and reduced our administrative costs significantly.",
    },
    {
      imageSrc: mariaImg,
      imageAlt: 'Profile picture of Michael Steiner',
      name: 'Michael Steiner',
      company: 'Founder, Quantum Capital',
      testimonial: "Our LPs love the transparency and liquidity options. We've seen a 30% increase in follow-on investments.",
    },
    {
      imageSrc: andreasImg,
      imageAlt: 'Profile picture of Aisha Rahman',
      name: 'Aisha Rahman',
      company: 'GP, Catalyst Fund',
      testimonial: "The compliance automation alone saved us hundreds of hours and allowed us to accept international investors seamlessly.",
    },
  ];

  const TestimonialCard: React.FC<TestimonialProps> = ({ imageSrc, imageAlt, name, company, testimonial }) => (
    <article className="flex flex-col flex-1 shrink p-6 rounded-md basis-0 bg-stone-300 bg-opacity-10 min-w-[240px] max-md:px-5 max-md:max-w-full">
      <header className="flex gap-2 self-start">
        <img
          loading="lazy"
          src={imageSrc}
          alt={imageAlt}
          className="object-contain shrink-0 self-start w-14 aspect-square"
        />
        <div className="flex flex-col justify-between">
          <h3 className="text-2xl font-semibold tracking-normal leading-none">
            {name}
          </h3>
          <p className="mt-1.5 text-base leading-none">{company}</p>
        </div>
      </header>
      <blockquote className="flex-1 shrink gap-2 self-stretch mt-6 w-full text-base leading-6 max-md:max-w-full">
        "{testimonial}"
      </blockquote>
    </article>
  );

  return (
    <section className="flex gap-10 py-6 text-slate-900">
      <div className="flex flex-col flex-1 shrink w-full basis-0 min-w-[240px] max-md:max-w-full">
        <h2 className="text-5xl font-extrabold tracking-tight leading-none max-md:max-w-full max-md:text-4xl">
          Fund Manager Success Stories
        </h2>
        <div className="flex flex-wrap gap-6 mt-6 w-full max-md:max-w-full">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};
